import React from 'react';
import { motion } from 'framer-motion';

const TeamCard = ({ member, index }) => {
    return (
        <motion.div
            className="col-md-4 mb-4"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.2 }}
        >
            <div className="card team-card h-100">
                <div className="card-body text-center p-4">
                    <div className="position-relative mb-3">
                        <img
                            src={member.image || `https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80`}
                            alt={member.name}
                            className="rounded-circle mb-3"
                            style={{ width: '150px', height: '150px', objectFit: 'cover' }}
                        />
                        <div className="position-absolute bottom-0 end-0 bg-primary-red text-white rounded-circle p-2">
                            <i className="fas fa-briefcase"></i>
                        </div>
                    </div>
                    <h5 className="card-title mb-2">{member.name}</h5>
                    <h6 className="text-primary-red mb-3">{member.position}</h6>
                    <p className="card-text text-muted small">{member.bio}</p>
                    <div className="mt-3">
                        <span className="badge bg-primary-blue me-2">{member.experience}</span>
                        <span className="badge bg-primary-red">{member.education}</span>
                    </div>
                </div>
            </div>
        </motion.div>
    );
};

export default TeamCard;